import { useState } from 'react';

import { PresetServerError, updatePresetItems } from 'config/requests/presets';
import { PresetItemFormValue } from 'pages/Presets/PresetsCreate/PresetsCreateForm/PresetsCreateForm';
import { mapFormValueToPresetItem } from 'pages/Presets/utils/mapFormValueToPresetItem';
import { useEditController, useNotify } from 'react-admin';
import { Preset } from 'types/embedded/preset';
import { getId } from 'utils/getId';

type Props = {
  direction: 'payment_items' | 'payout_items';
  onSuccess: () => void;
};

export const useEditPresets = ({ direction, onSuccess }: Props) => {
  const notify = useNotify();
  const { record } = useEditController<Preset>();
  const [error, setError] = useState<PresetServerError | null>(null);

  const handleSubmit = async (data: { items: PresetItemFormValue[] }) => {
    setError(null);
    const presetItems = data.items.map(mapFormValueToPresetItem);

    try {
      await updatePresetItems(getId(record?.id), direction, presetItems);
      onSuccess();
    } catch (e) {
      const err = e as PresetServerError;
      if (err.violations?.length) {
        const text = err.violations
          .map(({ propertyPath, message }) =>
            propertyPath ? `${propertyPath}: ${message}` : message,
          )
          .join(' ');
        notify(`Ошибка: ${text}`, {
          type: 'error',
          autoHideDuration: 5000,
        });
      } else {
        notify(`Ошибка: ${err.message || 'ошибка сервера'}`, {
          type: 'error',
          autoHideDuration: 3000,
        });
      }
      setError(err);
    }
  };

  return { handleSubmit, error, record };
};
